var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { TextField } from '@material-ui/core';
import { useResource } from 'rest-hooks';
import AdminFormResource from "../../../../api/AdminFormResource";
import { MenuItem } from "@wordpress/components";
const FormSelector = (_a) => {
    var { value, setValue } = _a, props = __rest(_a, ["value", "setValue"]);
    const resource = useResource(AdminFormResource.list(), {});
    if (resource && resource.length > 0) {
        return (React.createElement(TextField, Object.assign({ value: value, fullWidth: true, select: true, error: !value, helperText: !value && "Merci de sélectionner un formulaire", onChange: (e) => setValue(e.target.value) }, props), resource && resource.length > 0 && resource.map((element) => React.createElement(MenuItem, { key: element.slug, value: element.slug }, element.name))));
    }
    else {
        return React.createElement("div", null, "Aucun formulaire disponible, rendez vous dans l'administration des formulaire pour en cr\u00E9er un");
    }
};
export default FormSelector;
//# sourceMappingURL=FormSelector.js.map